import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/** Only `/login` and `/signup` use light theme; all other routes use Tailwind `dark` mode. */
const LIGHT_AUTH_PATHS = new Set(['/login', '/signup']);

export function DocumentThemeSync() {
  const { pathname } = useLocation();

  useEffect(() => {
    const root = document.documentElement;
    if (LIGHT_AUTH_PATHS.has(pathname)) {
      root.classList.remove('dark');
    } else {
      root.classList.add('dark');
    }
  }, [pathname]);

  return null;
}
